import React, {useContext, useEffect, useState} from 'react';
import ComponentTitle from "../Component-title/ComponentTitle";
import Slider from "react-slick";
import {axios} from "../../axios";
import {Link} from "react-router-dom";
import {Typography} from "@mui/material";
import {LangContext} from "../../App";
import {handleImageUrl} from "../../helpers";
const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical:false,
};

const HomeArmenia = () => {
    const [tours, setTours] = useState([]);
    const lang = useContext(LangContext)

    useEffect(() => {
        axios.get(`${lang}/armenia?main_page=true`).then(res => {
            if (Array.isArray(res.data.tours)) {
                setTours(res.data.tours);
            } else {
                console.error('API response is not an array:', res.data);
            }
        }).catch(error => {
            console.error('Error fetching tours:', error);
        });
    }, [lang]);

    const content = {
        en:{
            title1:"About",
            title2:"Armenia"
        },
        de:{
            title1:"Über",
            title2:"Armenien"
        }
    }

    const {title1,title2} = content[lang] || content.en

    return (
        <div className='home-armenia'>
            <ComponentTitle title={''} subTitle={title1} subTitle2={title2}/>
            <div className="slider-wrapper">
                <div className="slider-aside">
                    <Slider {...settings}>
                        {tours.map(e => {
                            if (!e) return null;
                            const image = handleImageUrl(e.thumbnail)
                            return (
                                <Link key={e.id} to={`/armenia/${e.id}`} className='slider-image-wrapper position-relative'>
                                    {image && <img src={image} alt="Ayrarat"/>}
                                    <Typography sx={{
                                        position:'absolute',
                                        bottom:'30px',
                                        left:'10px',
                                        color:'white',
                                        zIndex:'10',
                                        fontSize:'20px !important'
                                    }}>{e.title}</Typography>
                                </Link>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default HomeArmenia;